import { UPDATE_INVENTORY_INFO_ERROR } from '../../actions/exchange';
import {
  NAVIGATION_TO_LANDING_PAGE,
  NAVIGATION_TO_STEP_1,
  NAVIGATION_TO_STEP_2,
} from '../../actions/page';
import {
  RECEIVE_UNEVEN_EXCHANGE_DATA,
  SET_UNEVEN_EXCHANGE_STEP,
  SET_EXCHANGE_TO,
  RESET_UNEVEN_EXCHANGES_STATE,
  RECEIVE_CALCULATE_CART_DATA,
  RECEIVE_CREATE_CART_DATA,
  RECEIVE_UNEVEN_EXCHANGE_PAYMENT_AUTH,
  STEPS,
  SET_IS_UNEVEN_EXCHANGE_SUBMIT,
} from '../../actions/unevenExchanges';

export const initialState = {
  exchangeOptions: undefined,
  exchangeVariants: undefined,
  quantityOptions: undefined,
  exchangeTo: undefined,
  step: STEPS.RETURN_ITEM_DETAILS,
  calculatedCart: undefined,
  createdCart: undefined,
  isPaymentDue: undefined,
  paymentAuthorization: undefined,
  isUnevenExchangeSubmit: undefined,
};

export default (
  state = initialState,
  {
    type,
    data: {
      exchangeOptions,
      exchangeVariants,
      quantityOptions,
      step,
      exchangeTo,
      calculatedCart,
      createdCart,
      paymentAuthorization,
      isUnevenExchangeSubmit,
    } = {},
  } = {},
) => {
  switch (type) {
    case RECEIVE_UNEVEN_EXCHANGE_DATA:
      return {
        ...state,
        exchangeOptions,
        exchangeVariants,
        quantityOptions,
      };

    case SET_UNEVEN_EXCHANGE_STEP:
      return {
        ...state,
        step,
      };

    case SET_EXCHANGE_TO:
      return {
        ...state,
        exchangeTo,
      };

    case RECEIVE_CALCULATE_CART_DATA:
      return {
        ...state,
        calculatedCart,
        isPaymentDue:
          !!calculatedCart?.summary?.total?.price_in_cents &&
          calculatedCart?.summary?.total?.price_in_cents > 0,
      };

    case RECEIVE_UNEVEN_EXCHANGE_PAYMENT_AUTH:
      return {
        ...state,
        paymentAuthorization,
      };

    case RECEIVE_CREATE_CART_DATA:
      return {
        ...state,
        createdCart,
      };

    case SET_IS_UNEVEN_EXCHANGE_SUBMIT:
      return {
        ...state,
        isUnevenExchangeSubmit,
      };

    case NAVIGATION_TO_LANDING_PAGE:
    case NAVIGATION_TO_STEP_1:
    case NAVIGATION_TO_STEP_2:
    case UPDATE_INVENTORY_INFO_ERROR:
    case RESET_UNEVEN_EXCHANGES_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
